import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import ReceptionFilterTabs from "../components/ReceptionFilterTabs";

import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import QrReader from "react-qr-scanner";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Alert,
  IconButton,
  Box,
  TextField,
  InputAdornment,
  useMediaQuery,
  Collapse,
  CircularProgress,
  Stack,
  Tooltip,
} from "@mui/material";
import {
  checkGuestAttend,
  updateAttendanceManually,
  fetchReceptionList,
} from "../Service";
import ReceptionTable from "../components/ReceptionTable";
import ScanCompDialog from "../components/ScanCompDialog";
import { io } from "socket.io-client";
import Navbar from "../components/Navbar";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Fab from "@mui/material/Fab";
import ClearIcon from "@mui/icons-material/Clear";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

const Reception = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIsAttend, setSelectedIsAttend] = useState("all");
  const [selectedSide, setSelectedSide] = useState("all");
  const [openAlert, setOpenAlert] = useState(false);
  const [arrangements, setArrangements] = useState([]);

  const [data, setData] = useState("No result");
  const [isScanning, setIsScanning] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [guestInfo, setGuestInfo] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [scanDialogOpen, setScanDialogOpen] = useState(false);
  const [selectedInvitee, setSelectedInvitee] = useState(null);
  const [newAttendanceStatus, setNewAttendanceStatus] = useState("");
  const [appbarHeight, setAppbarHeight] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadArrangementsWithGuests();
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight); // Navbarの高さをstateに保存
    }

    const socket = io(API_URL, {
      transports: ["websocket"],
      query: { type: "RECEPTION" },
    });

    socket.on("updateReceptionTable", () => {
      console.log("Received updateReceptionTable event");
      loadArrangementsWithGuests();
    });

    return () => {
      socket.off("updateReceptionTable");
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight);
    }
  }, [loading]);

  const loadArrangementsWithGuests = async () => {
    setLoading(true);
    try {
      const response = await fetchReceptionList();
      console.log(response);
      // APIのレスポンスを確認したら、arrangementsを設定
      const arrangementsWithDefaults = response.arrangements.map(
        (arrangement) => ({
          ...arrangement,
          guests: arrangement.guests || [],
        })
      );
      setArrangements(arrangementsWithDefaults);
      console.log(response.unarranged_guests);
      // setUnarrangedGuests(response.unarranged_guests || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching arrangements with guests:", error);
      setErrorMessage("Error fetching arrangements.");
      setLoading(false);
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false);
      }, 3000);
    }
  };

  const handleScan = async (result) => {
    if (result) {
      setIsScanning(false);
      const scannedData = typeof result === "object" ? result.text : result;
      setData(scannedData);

      if (!scannedData.startsWith("MN-")) {
        setErrorMessage("無効なQRコードです。");
        setErrorDialogOpen(true);
        // setIsScanning(false);
        return;
      }

      const guestId = scannedData.substring(3);
      try {
        const guestData = await checkGuestAttend(guestId);
        setGuestInfo(guestData);
        setIsScanning(false);
        setScanDialogOpen(true);
      } catch (error) {
        setErrorMessage(error.message);
        setErrorDialogOpen(true);
        setIsScanning(false);
      }
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const toggleScan = () => {
    setIsScanning(!isScanning);
  };

  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
  };

  const handleEditClick = (invitee) => {
    setSelectedInvitee(invitee);
    setNewAttendanceStatus(invitee.is_attend === "yes" ? "no" : "yes"); // 現在の状態から逆にする
    setEditDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setEditDialogOpen(false);
    setSelectedInvitee(null);
  };

  const handleConfirmEdit = async () => {
    if (selectedInvitee) {
      try {
        await updateAttendanceManually(selectedInvitee.id, newAttendanceStatus);
        loadArrangementsWithGuests();
      } catch (error) {
        setErrorMessage("更新に失敗しました。");
        setErrorDialogOpen(true);
      }
      handleCloseDialog();
    }
  };

  const handleAutoReception = () => {
    navigate("/host/reception/auto"); // AutoReception に遷移
  };

  const handleSideChange = async (event, newValue) => {
    setSelectedSide(newValue);
  };

  // 参加状況を変更するハンドラ
  const handleIsAttendChange = (event, newValue) => {
    setSelectedIsAttend(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredArrangements = arrangements.filter((arrangement) => {
    if (selectedSide === "groom") {
      return arrangement.side === "groom";
    } else if (selectedSide === "bride") {
      return arrangement.side === "bride";
    }
    return true; // "all" の場合は全て表示
  });

  // 全角/半角の統一、カタカナ→ひらがな、空白削除、英字は小文字化
  const normalizeJP = (s = "") =>
    s
      .toString()
      .normalize("NFKC")
      .toLowerCase()
      // カタカナ→ひらがな
      .replace(/[\u30A1-\u30F6]/g, (ch) =>
        String.fromCharCode(ch.charCodeAt(0) - 0x60)
      )
      // 半角/全角スペースを除去
      .replace(/[\s\u3000]/g, "");

  // フィルタリングロジックを追加
  const filteredGuests = (guests) => {
    const needle = normalizeJP(searchTerm); // 入力を正規化（スペース除去、かな統一）

    return guests.filter((invitee) => {
      const isAttendMatch =
        selectedIsAttend === "all" || invitee.is_attend === selectedIsAttend;

      if (!needle) return isAttendMatch;

      const last = invitee.last_name || "";
      const first = invitee.first_name || "";
      const lastF = invitee.last_furigana || "";
      const firstF = invitee.first_furigana || "";
      const nick = invitee.nick_name || "";

      // 「姓+名」「名+姓」「姓かな+名かな」「名かな+姓かな」など
      const haystacks = [
        normalizeJP(last + first), // 中島輝征
        normalizeJP(first + last), // 輝征中島
        normalizeJP(lastF + firstF), // なかじまてるゆき ← ここでヒット！
        normalizeJP(firstF + lastF), // てるゆきなかじま
        normalizeJP(nick),
        // 既存の全部入り（順不同対策の保険）
        normalizeJP(`${first} ${firstF} ${last} ${lastF} ${nick}`),
      ];

      const textMatch = haystacks.some((h) => h.includes(needle));
      return isAttendMatch && textMatch;
    });
  };

  const getSideLabel = (side) => {
    switch (side) {
      case "groom":
        return "新郎";
      case "bride":
        return "新婦";
      default:
        return "未定義";
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <div className="content">
        {loading ? (
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1100,
            }}
          >
            <CircularProgress size={60} color="primary" />
          </Box>
        ) : (
          <>
            <Box
              sx={{
                position: "fixed",
                right: 0,
                bottom: 0,
                zIndex: 3000,
                width: "auto",
                maxWidth: "400px",
                padding: 2,
              }}
            >
              <Collapse in={openAlert}>
                <Alert
                  variant="filled"
                  severity="error"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpenAlert(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                  sx={{ mb: 2 }}
                >
                  {errorMessage}
                </Alert>
              </Collapse>
            </Box>

            {isSmallScreen ? (
              <AppBar position="fixed" id="appbar">
                <Toolbar>
                  <Navbar />
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ flexGrow: 1, ml: 2 }}
                  >
                    当日受付
                  </Typography>
                  {/* <Button color="inherit">Logout</Button> */}
                </Toolbar>
              </AppBar>
            ) : (
              <Navbar />
            )}

            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              flexDirection={{ xs: "column", sm: "row" }}
              size={12}
            >
              {isSmallScreen ? null : (
                <Stack
                  direction="row"
                  sx={{ height: "100%" }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <h2>当日受付</h2>
                </Stack>
              )}

              {isSmallScreen ? (
                <Box sx={{ marginTop: `${appbarHeight}px` }}></Box>
              ) : null}

              {isSmallScreen ? (
                <Grid
                  item
                  container
                  alignItems="center"
                  spacing={3}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder="検索..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon /> {/* アイコンを追加 */}
                          </InputAdornment>
                        ),
                      }}
                      style={{ width: "200px" }}
                    />
                  </Grid>

                  <Grid item container spacing={2}>
                    {isScanning ? (
                      <Fab size="small" color="secondary" onClick={toggleScan}>
                        <ClearIcon />
                      </Fab>
                    ) : (
                      <Fab size="small" color="primary" onClick={toggleScan}>
                        <QrCodeScannerIcon />
                      </Fab>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  item
                  container
                  spacing={3}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {isScanning ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<ClearIcon />}
                      onClick={toggleScan}
                    >
                      スキャン終了
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<QrCodeScannerIcon />}
                      onClick={toggleScan}
                    >
                      QRコードスキャン
                    </Button>
                  )}
                </Grid>
              )}
            </Grid>

            <Grid container spacing={3}>
              {isScanning ? (
                <Grid item size={12}>
                  <Box className="spacer-md"></Box>
                  {/* <QrScanner
                            delay={300}
                            onError={handleError}
                            onScan={handleScan}
                            style={{ width: '100%' }}
                            facingMode="front"
                        /> */}
                  <QrReader
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    style={{ width: "100%" }}
                    facingMode="rear"
                  />

                  {/* <CustomQrScanner
                            delay={300}
                            onError={handleError}
                            onScan={handleScan}
                            style={{ width: '100%' }}
                            facingMode="environment"
                        /> */}
                </Grid>
              ) : null}

              {/* エラーダイアログ */}
              <Dialog open={errorDialogOpen} onClose={handleCloseErrorDialog}>
                <DialogTitle>エラー</DialogTitle>
                <DialogContent>
                  <Typography variant="body1">{errorMessage}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseErrorDialog} color="primary">
                    閉じる
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  flexDirection={{ xs: "column", sm: "row" }}
                  size={12}
                >
                  <Grid sx={{ order: { xs: 2, sm: 1 } }}>
                    <ReceptionFilterTabs
                      selectedSide={selectedSide}
                      handleSideChange={handleSideChange}
                      selectedIsAttend={selectedIsAttend}
                      handleIsAttendChange={handleIsAttendChange}
                      arr={arrangements}
                    />
                  </Grid>
                  <Grid
                    container
                    columnSpacing={1}
                    sx={{ order: { xs: 1, sm: 2 } }}
                  >
                    <Grid
                      item
                      container
                      spacing={2}
                      xs={12}
                      md={6}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      {isSmallScreen ? null : (
                        <Grid
                          item
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Stack
                            direction="column"
                            spacing={2}
                            alignItems="flex-end"
                          >
                            <Button
                              variant="outlined"
                              sx={{ ml: 1, width: "fit-content" }}
                              onClick={handleAutoReception}
                            >
                              無人モード
                              <Tooltip title="この端末で、自動でゲストの受付を行います。">
                                <IconButton size="small">
                                  <HelpOutlineIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                            </Button>

                            <TextField
                              variant="outlined"
                              placeholder="検索..."
                              value={searchTerm}
                              onChange={handleSearchChange}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon />
                                  </InputAdornment>
                                ),
                              }}
                              style={{ width: "200px" }}
                            />
                          </Stack>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            <Box className="spacer-lg"></Box>

            <Grid container spacing={3} xs={12}>
              <Grid item xs={12} style={{ width: "100%" }}>
                <Grid container spacing={2}>
                  {filteredArrangements.map((arrangement) => (
                    <Grid
                      item
                      xs={12}
                      key={arrangement.id}
                      style={{ width: "100%" }}
                    >
                      <div className="guests-table" style={{ width: "100%" }}>
                        <ReceptionTable
                          invitees={filteredGuests(arrangement.guests)}
                          handleEditClick={handleEditClick}
                          arr_name={arrangement.arrangement_name}
                          arr_side={arrangement.side}
                          arr_id={arrangement.id}
                          load={loadArrangementsWithGuests}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          openAlert={openAlert}
                          setOpenAlert={setOpenAlert}
                        />
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>

            {/* 編集ダイアログ */}
            <Dialog open={editDialogOpen} onClose={handleCloseDialog}>
              <DialogTitle>手動受付</DialogTitle>
              <DialogContent>
                <Typography variant="body1">
                  {selectedInvitee?.last_name}
                  {selectedInvitee?.first_name} の受付を「
                  {newAttendanceStatus === "yes" ? "完了" : "未完了"}
                  」に変更してもよろしいですか？
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDialog} color="secondary">
                  キャンセル
                </Button>
                <Button onClick={handleConfirmEdit} color="primary">
                  変更
                </Button>
              </DialogActions>
            </Dialog>

            {/* ゲスト情報ダイアログ */}
            <ScanCompDialog
              open={scanDialogOpen}
              onClose={() => setScanDialogOpen(false)}
              guestInfo={guestInfo}
            />
          </>
        )}
      </div>
    </ThemeProvider>
  );
};

export default Reception;
